import statusesId from '@/constants/statusesId';
import permissions from '@/constants/permissions';

export default {
    data () {
        return {
            statusesId,
            permissions,
            hasPermissionsForAreaCorrecting: null,
            hasPermissionsForNationalCorrecting: null,
            hasPermissionForSheetEdit: null,
            hasPermissionsForAreaGiftGivingReportCorrecting: null,
            hasPermissionsForNationalGiftGivingReportCorrecting: null,
            hasPermissionForEditGiftGivingReport: null
        };
    },
    computed: {
        family () {
            return this.$store.getters['family/getFamily'];
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        familyStatusId () {
            if (this.family) {
                return this.family.status.family_edition_status_id || this.family.status.id;
            }
        },
        availableStatusesForAudit () {
            return [
                this.statusesId.FAMILY_VERIFIED_AREA_REACH,
                this.statusesId.FAMILY_VERIFIED_NATIONAL_REACH,
                this.statusesId.SEND_BACK_AREA_REACH,
                this.statusesId.SEND_BACK_NATIONAL_REACH,
                this.statusesId.PUBLICATION_REVOKED,
                this.statusesId.PUBLISHED,
                this.statusesId.HAS_GIFTGIVER
            ];
        },
        availableStatusesForGiftAudit () {
            return [
                this.statusesId.GIFT_GIVING_REPORT_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_NATIONAL_REACH
            ];
        },
        availableStatusesForAddComment () {
            return [
                this.statusesId.FAMILY_VERIFIED_AREA_REACH,
                this.statusesId.FAMILY_VERIFIED_NATIONAL_REACH,
                this.statusesId.SEND_BACK_AREA_REACH,
                this.statusesId.SEND_BACK_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_NATIONAL_REACH
            ];
        },
        isPublicationRevoked () {
            return this.familyStatusId === this.statusesId.PUBLICATION_REVOKED;
        },
        availableStatusesForSendingToAreaAudit () {
            return [this.statusesId.CREATING_DESCRIPTION, this.statusesId.SEND_BACK_AREA_REACH];
        },
        availableStatusesForSendingOnNationalAudit () {
            return [this.statusesId.SEND_BACK_NATIONAL_REACH];
        },
        availableStatusesForEditSheets () {
            return [
                this.statusesId.SEND_BACK_AREA_REACH,
                this.statusesId.SEND_BACK_NATIONAL_REACH,
                this.statusesId.CREATING_FIRST_SHEET,
                this.statusesId.CREATING_SECOND_SHEET,
                this.statusesId.CREATING_DESCRIPTION
            ];
        },
        availableStatusesForEditGiftGivingReport () {
            return [
                this.statusesId.GIFT_GIVING_REPORT_BACK_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_DESCRIBED,
                this.statusesId.HAS_GIFTGIVER
            ];
        },
        availableStatusesForSaveGiftDraft () {
            return [this.statusesId.GIFT_GIVING_REPORT_DESCRIBED, this.statusesId.HAS_GIFTGIVER];
        },
        hasSheetEditPermission () {
            if (this.availableStatusesForEditSheets.includes(this.familyStatusId)) {
                return this.hasPermissionForSheetEdit;
            }
            return false;
        },
        showSheetCommentMark () {
            if (this.availableStatusesForAudit.includes(this.familyStatusId)) {
                return (
                    this.hasPermissionsForAreaCorrecting ||
          this.hasPermissionsForNationalCorrecting ||
          this.hasSheetEditPermission
                );
            }
            return false;
        },
        showAuditCard () {
            if (this.availableStatusesForAudit.includes(this.familyStatusId) && this.isCurrentEdition) {
                return (
                    this.hasPermissionsForAreaCorrecting ||
          this.hasPermissionsForNationalCorrecting ||
          this.editSheetsAndComment
                );
            }
            return false;
        },
        editSheetsAndComment () {
            if (this.availableStatusesForEditSheets.includes(this.familyStatusId)) {
                return this.hasPermissionForSheetEdit;
            }
            return false;
        },
        showGiftAuditCard () {
            if (this.availableStatusesForGiftAudit.includes(this.familyStatusId)) {
                return this.hasPermissionsToAddGiftComment || this.editGiftGivingReportAndComment;
            }
            return false;
        },
        editGiftGivingReportAndComment () {
            return this.canEditGiftGivingReport;
        },
        hasPermissionsToAddComment () {
            return this.hasPermissionsForAreaCorrecting || this.hasPermissionsForNationalCorrecting;
        },
        hasPermissionsToAddGiftComment () {
            return (
                this.hasPermissionsForAreaGiftGivingReportCorrecting ||
        this.hasPermissionsForNationalGiftGivingReportCorrecting
            );
        },
        isFamilyVerifiedInArea () {
            return this.familyStatusId === this.statusesId.FAMILY_VERIFIED_AREA_REACH;
        },
        isFamilyVerifiedOnNational () {
            return this.familyStatusId === this.statusesId.FAMILY_VERIFIED_NATIONAL_REACH;
        },
        isFamilyVerifiedInAreaForGift () {
            return this.familyStatusId === this.statusesId.GIFT_GIVING_REPORT_AREA_REACH;
        },
        isFamilyVerifiedOnNationalForGift () {
            return this.familyStatusId === this.statusesId.GIFT_GIVING_REPORT_NATIONAL_REACH;
        },
        isFamilyCorrectingOnNationalForGift () {
            return this.familyStatusId === this.statusesId.GIFT_GIVING_REPORT_BACK_NATIONAL_REACH;
        },
        canDoAuditInArea () {
            return (
                (this.hasPermissionsForAreaCorrecting || this.hasPermissionsForNationalCorrecting) &&
        this.isFamilyVerifiedInArea
            );
        },
        canDoAuditOnNational () {
            return this.hasPermissionsForNationalCorrecting && this.isFamilyVerifiedOnNational;
        },
        canDoGiftGivingReportAuditInArea () {
            return this.hasPermissionsToAddGiftComment && this.isFamilyVerifiedInAreaForGift;
        },
        canDoGiftGivingReportAuditOnNational () {
            return (
                this.hasPermissionsForNationalGiftGivingReportCorrecting &&
        this.isFamilyVerifiedOnNationalForGift
            );
        },
        canSendFamilyToAreaAudit () {
            return this.availableStatusesForSendingToAreaAudit.includes(this.familyStatusId);
        },
        canSendFamilyToNationalAudit () {
            return this.availableStatusesForSendingOnNationalAudit.includes(this.familyStatusId);
        },
        commentLevel () {
            if (this.isAreaStatus) {
                return 'area';
            }
            if (this.isNationalStatus) {
                return 'national';
            }
            return '';
        },
        isAreaStatus () {
            return [
                this.statusesId.SEND_BACK_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_AREA_REACH,
                this.statusesId.FAMILY_VERIFIED_AREA_REACH
            ].includes(this.familyStatusId);
        },
        isNationalStatus () {
            return [
                this.statusesId.SEND_BACK_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_NATIONAL_REACH,
                this.statusesId.FAMILY_VERIFIED_NATIONAL_REACH,
                this.statusesId.PUBLICATION_REVOKED
            ].includes(this.familyStatusId);
        },
        canAddComment () {
            if (
                ![...this.availableStatusesForAddComment, this.statusesId.PUBLICATION_REVOKED].includes(
                    this.familyStatusId
                )
            ) {
                return false;
            }

            if (this.isFamilyVerifiedOnNational || this.isPublicationRevoked) {
                return this.hasPermissionsForNationalCorrecting;
            }
            if (this.isFamilyVerifiedInArea) {
                return this.hasPermissionsToAddComment;
            }
            return this.hasPermissionForSheetEdit;
        },
        canAddGiftComment () {
            if (!this.availableStatusesForAddComment.includes(this.familyStatusId)) return false;

            if (this.isFamilyVerifiedOnNationalForGift) {
                return this.hasPermissionsForNationalGiftGivingReportCorrecting;
            }
            if (this.isFamilyVerifiedInAreaForGift) {
                return this.hasPermissionsToAddGiftComment;
            }
            return this.hasPermissionsToAddGiftComment || this.hasPermissionForEditGiftGivingReport;
        },
        canEditSheets () {
            if (this.availableStatusesForEditSheets.includes(this.familyStatusId)) {
                return this.hasPermissionForSheetEdit;
            }
            if (this.familyStatusId === this.statusesId.PUBLICATION_REVOKED) {
                return this.hasPermissionsForNationalCorrecting;
            }
            if (this.familyStatusId === this.statusesId.DISABLED) {
                return false;
            }
            return true;
        },
        canEditGiftGivingReport () {
            if (this.availableStatusesForEditGiftGivingReport.includes(this.familyStatusId)) {
                return this.hasPermissionForEditGiftGivingReport;
            }
        },
        canSendPreCreateGift () {
            if (this.statusesId.HAS_GIFTGIVER === this.familyStatusId) {
                return this.hasPermissionForEditGiftGivingReport;
            }
        },
        canSaveGiftDraft () {
            if (this.availableStatusesForSaveGiftDraft.includes(this.familyStatusId)) {
                return this.hasPermissionForEditGiftGivingReport;
            }
        },
        activeGiftGivingReportButton () {
            return (
                this.canEditGiftGivingReport ||
        this.canDoGiftGivingReportAuditInArea ||
        this.canDoGiftGivingReportAuditOnNational
            );
        }
    },
    created () {
        this.$store
            .dispatch('auth/hasPermission', this.permissions.SHEET_CORRECTING_AREA)
            .then((res) => {
                this.hasPermissionsForAreaCorrecting = res;
            });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.SHEET_CORRECTING_NATIONAL)
            .then((res) => {
                this.hasPermissionsForNationalCorrecting = res;
            });
        this.$store.dispatch('auth/hasPermission', this.permissions.SHEET_EDIT).then((result) => {
            this.hasPermissionForSheetEdit = result;
        });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.GIFT_GIVING_REPORT_CORRECTING_AREA)
            .then((result) => {
                this.hasPermissionsForAreaGiftGivingReportCorrecting = result;
            });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.GIFT_GIVING_REPORT_CORRECTING_NATIONAL)
            .then((result) => {
                this.hasPermissionsForNationalGiftGivingReportCorrecting = result;
            });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.GIFTGIVER_EDIT_GIFT_GIVING_REPORT)
            .then((result) => {
                this.hasPermissionForEditGiftGivingReport = result;
            });
    }
};
